import { Component, EventEmitter, HostListener, Input, Output, TemplateRef } from '@angular/core'
import { debounce } from 'lodash-es'
import { ActivePopoverStateService, PopoverState } from '../../services'

const DROPDOWN_DISPLAY_DELAY = 125

@Component({
  selector: 'ftr-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.css'],
})
export class DropdownComponent implements PopoverState {
  @Input() title?: string
  @Input() headerTemplate: TemplateRef<any> | null = null
  @Input() closeOnBodyClick: boolean = true

  // eslint-disable-next-line @angular-eslint/no-output-rename
  @Output('isOpen') statusChangeEmitter = new EventEmitter<boolean>()

  constructor(private readonly activePopoverStateService: ActivePopoverStateService) {}

  get isShowing(): boolean {
    return this.activePopoverStateService.activePopover === this
  }

  toggle(): void {
    if (!this.isShowing) {
      this.open()
    } else {
      this.close()
    }
  }

  open(_?: MouseEvent | FocusEvent | undefined): void {
    this.openDebounce()
  }

  close(_?: Event): void {
    this.closeDebounce()
  }

  handleBodyClick(): void {
    if (this.isShowing && this.closeOnBodyClick) {
      this.close()
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  handleOnEscape($event: KeyboardEvent): void {
    if (this.isShowing) {
      this.close()
      $event.stopPropagation()
    }
  }

  @HostListener('keydown.Enter', ['$event'])
  handleOnEnter($event: KeyboardEvent): void {
    this.toggle()
    $event.stopPropagation()
  }

  private openDebounce = debounce(() => {
    this.activePopoverStateService.activate(this)
    this.statusChangeEmitter.emit(true)
  }, DROPDOWN_DISPLAY_DELAY)

  private closeDebounce = debounce(() => {
    this.activePopoverStateService.deactivate()
    this.statusChangeEmitter.emit(false)
  }, 0)
}
